export const DEVICE_STATUS = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    EXPIRED: 'expired',
    INACTIVE: 'inactive',
    INVITED: 'invited',
    SYNCNEEDED: 'sync needed',
    AWAITING_APPROVAL: 'awaiting approval',
    REVOKED: 'revoked'
};

export const DEVICE_STATUSES = {
    [DEVICE_STATUS.ENABLED]: {
        background: 'rgba(45, 143, 87, .1)',
        border: 'rgba(45, 143, 87, 1)',
        color: 'rgba(45, 143, 87, 1)'
    },
    [DEVICE_STATUS.INACTIVE]: {
        background: 'rgba(255, 192, 0, .1)',
        border: 'rgba(255, 192, 0, 1)',
        color: 'rgba(255, 192, 0, 1)'
    },
    [DEVICE_STATUS.INVITED]: {
        background: 'rgba(255, 192, 0, .1)',
        border: 'rgba(255, 192, 0, 1)',
        color: 'rgba(255, 192, 0, 1)'
    },
    [DEVICE_STATUS.DISABLED]: {
        background: 'rgba(255, 0, 0, .1)',
        border: 'rgba(255, 0, 0, 1)',
        color: 'rgba(255, 0, 0, 1)'
    },
    [DEVICE_STATUS.SYNCNEEDED]: {
        background: 'rgba(255, 0, 0, .1)',
        border: 'rgba(255, 0, 0, 1)',
        color: 'rgba(255, 0, 0, 1)'
    },
    [DEVICE_STATUS.EXPIRED]: {
        background: 'rgba(128, 128, 128, .1)',
        border: 'rgba(128, 128, 128, 1)',
        color: 'rgba(128, 128, 128, 1)'
    },
    [DEVICE_STATUS.AWAITING_APPROVAL]: {
        background: 'rgba(22, 119, 255, .1)',
        border: 'rgba(22, 119, 255, 1)',
        color: 'rgba(22, 119, 255, 1)'
    },
    [DEVICE_STATUS.REVOKED]: {
        background: 'rgba(128, 128, 128, .1)',
        border: 'rgba(128, 128, 128, 1)',
        color: 'rgba(128, 128, 128, 1)'
    }
};
